/**
 * Einsatzgebiet: Bremer Stadt-/Ortsteile + direktes Umland mit echten Geokoordinaten.
 * zone: "kern" = Bremer Stadtgebiet, "umland" = direktes Umland (auf Anfrage)
 */
export const AREAS = [
  // ---- Bremen-Nord ----
  { n: "Blumenthal", lat: 53.1897, lng: 8.558, zone: "kern" },
  { n: "Farge", lat: 53.218, lng: 8.508, zone: "kern" },
  { n: "Rekum", lat: 53.227, lng: 8.492, zone: "kern" },
  { n: "Rönnebeck", lat: 53.183, lng: 8.539, zone: "kern" },
  { n: "Vegesack", lat: 53.169, lng: 8.618, zone: "kern" },
  { n: "Grohn", lat: 53.162, lng: 8.635, zone: "kern" },
  { n: "Aumund", lat: 53.174, lng: 8.6, zone: "kern" },
  { n: "Schönebeck", lat: 53.176, lng: 8.64, zone: "kern" },
  { n: "Burglesum", lat: 53.174, lng: 8.67, zone: "kern" },
  { n: "Lesum", lat: 53.17, lng: 8.68, zone: "kern" },
  { n: "St. Magnus", lat: 53.18, lng: 8.66, zone: "kern" },
  { n: "Burg-Grambke", lat: 53.147, lng: 8.665, zone: "kern" },

  // ---- Westen ----
  { n: "Oslebshausen", lat: 53.125, lng: 8.7, zone: "kern" },
  { n: "Gröpelingen", lat: 53.115, lng: 8.73, zone: "kern" },
  { n: "Ohlenhof", lat: 53.118, lng: 8.742, zone: "kern" },
  { n: "Walle", lat: 53.101, lng: 8.773, zone: "kern" },
  { n: "Utbremen", lat: 53.093, lng: 8.78, zone: "kern" },
  { n: "Überseestadt", lat: 53.102, lng: 8.762, zone: "kern" },
  { n: "Hohweg", lat: 53.11, lng: 8.75, zone: "kern" },

  // ---- Mitte ----
  { n: "Findorff", lat: 53.094, lng: 8.801, zone: "kern" },
  { n: "Weidedamm", lat: 53.099, lng: 8.806, zone: "kern" },
  { n: "Altstadt", lat: 53.076, lng: 8.807, zone: "kern" },
  { n: "Bahnhofsvorstadt", lat: 53.083, lng: 8.814, zone: "kern" },
  { n: "Ostertor", lat: 53.072, lng: 8.818, zone: "kern" },
  { n: "Steintor", lat: 53.073, lng: 8.833, zone: "kern" },
  { n: "Fesenfeld", lat: 53.076, lng: 8.842, zone: "kern" },
  { n: "Peterswerder", lat: 53.069, lng: 8.845, zone: "kern" },

  // ---- Nordosten ----
  { n: "Schwachhausen", lat: 53.088, lng: 8.84, zone: "kern" },
  { n: "Riensberg", lat: 53.096, lng: 8.844, zone: "kern" },
  { n: "Neu-Schwachhausen", lat: 53.098, lng: 8.833, zone: "kern" },
  { n: "Horn-Lehe", lat: 53.109, lng: 8.878, zone: "kern" },
  { n: "Lehesterdeich", lat: 53.114, lng: 8.87, zone: "kern" },
  { n: "Borgfeld", lat: 53.129, lng: 8.922, zone: "kern" },
  { n: "Oberneuland", lat: 53.094, lng: 8.908, zone: "kern" },
  { n: "Blockland", lat: 53.123, lng: 8.776, zone: "kern" },

  // ---- Osten / Südosten ----
  { n: "Vahr", lat: 53.079, lng: 8.87, zone: "kern" },
  { n: "Neue Vahr Nord", lat: 53.086, lng: 8.87, zone: "kern" },
  { n: "Hastedt", lat: 53.064, lng: 8.865, zone: "kern" },
  { n: "Sebaldsbrück", lat: 53.068, lng: 8.893, zone: "kern" },
  { n: "Hemelingen", lat: 53.059, lng: 8.906, zone: "kern" },
  { n: "Arbergen", lat: 53.06, lng: 8.94, zone: "kern" },
  { n: "Mahndorf", lat: 53.056, lng: 8.96, zone: "kern" },
  { n: "Osterholz", lat: 53.066, lng: 8.923, zone: "kern" },
  { n: "Tenever", lat: 53.059, lng: 8.934, zone: "kern" },
  { n: "Blockdiek", lat: 53.07, lng: 8.907, zone: "kern" },

  // ---- Süden ----
  { n: "Neustadt", lat: 53.067, lng: 8.796, zone: "kern" },
  { n: "Alte Neustadt", lat: 53.07, lng: 8.801, zone: "kern" },
  { n: "Buntentor", lat: 53.062, lng: 8.805, zone: "kern" },
  { n: "Hohentor", lat: 53.075, lng: 8.784, zone: "kern" },
  { n: "Südervorstadt", lat: 53.06, lng: 8.816, zone: "kern" },
  { n: "Huckelriede", lat: 53.055, lng: 8.813, zone: "kern" },
  { n: "Obervieland", lat: 53.043, lng: 8.813, zone: "kern" },
  { n: "Habenhausen", lat: 53.048, lng: 8.845, zone: "kern" },
  { n: "Arsten", lat: 53.035, lng: 8.823, zone: "kern" },
  { n: "Kattenturm", lat: 53.043, lng: 8.801, zone: "kern" },
  { n: "Kattenesch", lat: 53.034, lng: 8.808, zone: "kern" },

  // ---- Südwesten ----
  { n: "Woltmershausen", lat: 53.076, lng: 8.764, zone: "kern" },
  { n: "Rablinghausen", lat: 53.082, lng: 8.734, zone: "kern" },
  { n: "Seehausen", lat: 53.076, lng: 8.68, zone: "kern" },
  { n: "Strom", lat: 53.07, lng: 8.65, zone: "kern" },
  { n: "Grolland", lat: 53.064, lng: 8.754, zone: "kern" },
  { n: "Huchting", lat: 53.052, lng: 8.729, zone: "kern" },
  { n: "Kirchhuchting", lat: 53.049, lng: 8.721, zone: "kern" },
  { n: "Mittelshuchting", lat: 53.044, lng: 8.71, zone: "kern" },
  { n: "Sodenmatt", lat: 53.057, lng: 8.742, zone: "kern" },

  // ---- Umland (auf Anfrage) ----
  { n: "Schwanewede", lat: 53.225, lng: 8.59, zone: "umland" },
  { n: "Ritterhude", lat: 53.185, lng: 8.74, zone: "umland" },
  { n: "Osterholz-Scharmbeck", lat: 53.226, lng: 8.795, zone: "umland" },
  { n: "Lilienthal", lat: 53.143, lng: 8.9, zone: "umland" },
  { n: "Worpswede", lat: 53.223, lng: 8.927, zone: "umland" },
  { n: "Oyten", lat: 53.052, lng: 9.015, zone: "umland" },
  { n: "Achim", lat: 53.015, lng: 9.025, zone: "umland" },
  { n: "Thedinghausen", lat: 52.97, lng: 9.01, zone: "umland" },
  { n: "Weyhe", lat: 52.98, lng: 8.87, zone: "umland" },
  { n: "Leeste", lat: 52.997, lng: 8.79, zone: "umland" },
  { n: "Stuhr", lat: 52.996, lng: 8.74, zone: "umland" },
  { n: "Brinkum", lat: 53.016, lng: 8.788, zone: "umland" },
  { n: "Syke", lat: 52.914, lng: 8.82, zone: "umland" },
  { n: "Delmenhorst", lat: 53.05, lng: 8.63, zone: "umland" },
  { n: "Ganderkesee", lat: 53.036, lng: 8.54, zone: "umland" },
  { n: "Hude", lat: 53.11, lng: 8.46, zone: "umland" },
  { n: "Berne", lat: 53.17, lng: 8.5, zone: "umland" },
  { n: "Lemwerder", lat: 53.16, lng: 8.61, zone: "umland" },
];

export const AREA_COUNT = AREAS.length;
export const KERN_COUNT = AREAS.filter((a) => a.zone === "kern").length;
export const UMLAND_COUNT = AREAS.filter((a) => a.zone === "umland").length;

/** Firmensitz (Hauptbüro) */
export const HQ = { lat: 53.0906, lng: 8.7861, label: "Hauptbüro · Flughafenallee 26" };
/** Fuhrpark-Start */
export const DEPOT = { lat: 53.059, lng: 8.906, label: "Fuhrpark · Bremen-Hemelingen" };
